import Component from '@glimmer/component';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapRoiIndexComponent extends Component {
  get initiatives() {
    return this.args.data.source;
  }

  get roadmap() {
    return this.args.roadmap;
  }

  // FIXME: There should be a better way to filter out elements in a dataset.
  get customerInitiatives() {
    return this.filter_on_field(
      this.initiatives,
      'source',
      'CUSTOMER REQUEST CURRENT',
    );
  }

  // FIXME: There should be a better way to filter out elements in a dataset.
  get visionInitiatives() {
    return this.filter_on_field(this.initiatives, 'source', 'VISION');
  }

  // FIXME: There should be a better way to filter out elements in a dataset.
  get maintenanceInitiatives() {
    return this.filter_on_field(
      this.initiatives,
      'source',
      'OPERATIONS AND MAINTENANCE',
    );
  }

  // TODO: Bring back OTHER and Undefined as a chart.
  get otherInitiatives() {
    const notClassified =
      this.filter_on_field(this.initiatives, 'source', null) ?? [];
    const other = this.filter_on_field(this.initiatives, 'source', 'OTHER');
    return notClassified.concat(other);
  }

  // FIXME: There should be a better way to filter out elements in a dataset.
  filter_on_field(dataset, field, value) {
    if (dataset == undefined) return undefined;
    const field_index = dataset[0].indexOf(field);
    const filtered_records = dataset.filter(
      (entry) => entry[field_index] === value,
    );
    const returns = [dataset[0]].concat(filtered_records);
    return returns;
  }
}

export default instrumentRoutePerformance(RoadmapRoiIndexComponent);
